export default __webpack_public_path__ + "static/media/2026-03-22 18.08.08.0ace66d0.jpg";